// API configuration
// Hardcode the Render URL to ensure it works in the iOS app
const API_BASE_URL = 'https://moneytracker-backend-i77k.onrender.com';



export function getApiUrl(path: string): string {
  // Remove leading slash from path if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // Always use the full URL
  return `${API_BASE_URL}/${cleanPath}`;
}

// Helper function for API requests
export async function apiRequest(path: string, options?: RequestInit) {
  const url = getApiUrl(path);
  
  // Get session token from localStorage
  const sessionToken = localStorage.getItem('sessionToken');
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };
  
  // Merge with existing headers if any
  if (options?.headers) {
    Object.assign(headers, options.headers);
  }
  
  // Add Authorization header if token exists
  if (sessionToken) {
    (headers as Record<string, string>)['Authorization'] = `Bearer ${sessionToken}`;
  }
  
  const response = await fetch(url, {
    ...options,
    credentials: 'include', // Important: send cookies for session
    headers,
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(error.message || `HTTP ${response.status}`);
  }
  
  return response;
}
